module.exports = __webpack_public_path__ + "img/bg_big_purple.16552926.svg";